import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {AbstractVisbosComponent} from '../../../core/visbos-core/components/abstract-visbos.component';
import {FormControl} from '@angular/forms';
import {SessionActions} from '../../../shared/actions';
import {Asset} from '../../../shared/view-model/store-management/asset.type';
import {AssetService} from '../../../store-management/asset-management/services/asset.service';

@Component({
  selector: 'vb-touch-asset-status',
  templateUrl: './touch-asset-status.component.html',
  styleUrls: ['./touch-asset-status.component.css']
})
export class TouchAssetStatusComponent extends AbstractVisbosComponent implements OnInit {

  allowedTypes = ['Asset', 'AssetTree'];
  searchForm: FormControl;

  lastAsset: Asset;

  constructor(sessionActions: SessionActions, private assetService: AssetService, cd: ChangeDetectorRef) {
    super(sessionActions, cd);
  }

  ngOnInit() {
    super.ngOnInit();
    this.searchForm = new FormControl();
  }

  barcodeFound(asset: Asset) {
    if (asset) {
      this.addSubscription(this.assetService.getAsset(asset.cuid)
        .subscribe((res) => {
          this.lastAsset = res.data.asset;
        }));
    }
  }

  assetFound(result: Asset) {
    this.lastAsset = result;
  }

  searchCleared() {
    this.lastAsset = null;
  }

  isUbdOver(ubd: Date) {
    if (new Date(ubd) < new Date()) {
      return true;
    }
    return false;
  }

}



// WEBPACK FOOTER //
// ./src/app/visbos-touch-client/ui/touch-asset-status/touch-asset-status.component.ts